import { TOGGLE_SELECTED_PROPERTY } from '../constants';

export const actionToggleSelectedProperty = selectedPropertyIndex => {
  return async dispatch => {
    dispatch({ type: TOGGLE_SELECTED_PROPERTY, selectedPropertyIndex });
  };
};

export default actionToggleSelectedProperty;
